import { createRoute, lazyRouteComponent } from "@tanstack/react-router"
import { Route as RootRoute } from "../__root"

/**
 * `/onboarding/step-1` — countries (create-capable).
 * Page body lazy-loaded.
 */
export const Route = createRoute({
	getParentRoute: () => RootRoute,
	path: "/onboarding/step-1",
	component: lazyRouteComponent(() => import("./step-1.page")),
})
